function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import TranslationManager from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/translation-manager';
import { TranslationKeys } from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/const';
import ApiClient from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/api/api-client';
import ModalDialog from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/components/modal-dialog';
import UserManagementEditModal from './user-management-edit-modal';
import Logger from '../../../../../../../wdh-foundation/wdh-logger/wdh-logger';
import CheckUtils from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/utilities/check-utils';
import Loader from 'react-loader-advanced';
import { loaderBackgroundStyle, loaderOpacity, spinner } from './views/Spinner';
import ConfigurationManager from "../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/configuration-manager";
var UserManagementUsersDataList = /*#__PURE__*/function (_React$Component) {
  function UserManagementUsersDataList(props) {
    var _this;
    _classCallCheck(this, UserManagementUsersDataList);
    _this = _callSuper(this, UserManagementUsersDataList, [props]);
    _this.state = {
      userList: [],
      showEditUserModal: false,
      showRemoveUserModal: false,
      businessEmailNotComplete: false,
      emailNotValidate: false,
      phoneNotComplete: false,
      phoneNotValid: false,
      toggleUserId: false,
      toggleUserName: false,
      showUpdateUserNotSuccessModal: false,
      editModalLoading: false,
      editModalSaveLoading: false,
      loggedUser: '',
      currentPage: 1,
      usersPerPage: 10,
      removeUserName: '',
      removeUserInfo: {},
      newSelectedRole: '',
      editUser: {
        name: '',
        id: '',
        existingRole: '',
        newRole: '',
        address: '',
        businessEmail: '',
        personalEmail: '',
        phone: '',
        fax: '',
        contactNo: '',
        custNo: '',
        contactRequestId: ''
      },
      updatedUserData: {}
    };
    _this.translations = {
      removeModalCancelText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_DATA_LIST_REMOVE_MODAL_CANCEL_TEXT),
      removeModalOKText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_DATA_LIST_REMOVE_MODAL_OK_TEXT),
      dataListEditText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_DATA_LIST_EDIT_TEXT),
      dataListManageText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_DATA_LIST_MANAGE_TEXT),
      dataListRemoveModalText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_DATA_LIST_REMOVE_MODAL_TEXT),
      dataListRemoveText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_DATA_LIST_REMOVE_TEXT),
      dataListRoleText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_DATA_LIST_ROLE_TEXT),
      dataListUserText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_DATA_LIST_USER_ID_TEXT),
      dataListUserNameText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_DATA_LIST_USER_NAME_TEXT),
      dataListNoUserFoundText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_DATA_LIST_NO_USERS_FOUND_TEXT),
      dataListUpdateFailedModalText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_DATA_LIST_UPDATE_FAILED_MODAL_TEXT)
    };
    _this.modalCancel = _this.modalCancel.bind(_this);
    _this.saveNewUser = _this.saveNewUser.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.passSelectedRole = _this.passSelectedRole.bind(_this);
    _this.handleSortUserNames = _this.handleSortUserNames.bind(_this);
    _this.handleSortUserID = _this.handleSortUserID.bind(_this);
    return _this;
  }
  _inherits(UserManagementUsersDataList, _React$Component);
  return _createClass(UserManagementUsersDataList, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.loadUserList();
      this.getLoggedUserId();
    }
  }, {
    key: "loadUserList",
    value: function loadUserList() {
      var _this2 = this;
      ApiClient.userManagement.getUserData().then(function (userList) {
        _this2.setState({
          userList: userList
        });
      });
    }
  }, {
    key: "getLoggedUserId",
    value: function getLoggedUserId() {
      var tokenDetails = ConfigurationManager.getTokenDetails();
      this.setState({
        loggedUser: tokenDetails.UserName
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      this.setState({
        currentPage: Number(event.target.id)
      });
    }
  }, {
    key: "passSelectedRole",
    value: function passSelectedRole(newRole) {
      this.setState({
        newSelectedRole: newRole
      });
    }
  }, {
    key: "openEditModal",
    value: function openEditModal(users) {
      var _this3 = this;
      this.setState({
        editModalLoading: true
      });
      ApiClient.userManagement.getUserEditUserData(users.loginId, users.contactNo, users.contactRequestId).then(function (user) {
        _this3.setState({
          editUser: user,
          editModalLoading: false,
          showEditUserModal: true
        });
      });
    }
  }, {
    key: "handleUpdateEditUser",
    value: function handleUpdateEditUser(businessEmail, personalEmail, phone, fax) {
      Logger.info(businessEmail + personalEmail + phone + fax);
      var editUser = this.state.editUser;
      editUser.businessEmail = businessEmail;
      editUser.personalEmail = personalEmail;
      editUser.phone = phone;
      editUser.fax = fax;
      this.setState({
        editUser: editUser,
        businessEmailNotComplete: false,
        emailNotValidate: false,
        phoneNotComplete: false,
        phoneNotValid: false
      });
    }
  }, {
    key: "onRemoveUserCanceled",
    value: function onRemoveUserCanceled() {
      this.setState({
        showRemoveUserModal: false,
        removeUserInfo: {},
        removeUserName: ''
      });
    }
  }, {
    key: "setUserData",
    value: function setUserData() {
      var _this$state = this.state,
        editUser = _this$state.editUser,
        newSelectedRole = _this$state.newSelectedRole;
      var updatedUserData = {};
      updatedUserData.loginId = editUser.loginId;
      CheckUtils.isNullOrEmptyString(newSelectedRole) ? updatedUserData.role = editUser.role : updatedUserData.role = newSelectedRole;
      updatedUserData.custNo = editUser.custNo;
      updatedUserData.businessEmail = editUser.businessEmail;
      updatedUserData.personalEmail = editUser.personalEmail;
      updatedUserData.phone = editUser.phone;
      updatedUserData.fax = editUser.fax;
      updatedUserData.contactRequestId = editUser.contactRequestId;
      return updatedUserData;
    }
  }, {
    key: "modalCancel",
    value: function modalCancel() {
      this.setState({
        showEditUserModal: false,
        businessEmailNotComplete: false,
        phoneNotComplete: false,
        emailNotValidate: false,
        phoneNotValid: false,
        newSelectedRole: '',
        editUser: {}
      });
    }
  }, {
    key: "openRemoveModal",
    value: function openRemoveModal(users) {
      this.setState({
        removeUserInfo: {
          loginId: users.loginId,
          contactId: users.contactNo,
          custNo: users.custNo
        },
        removeUserName: users.name,
        showRemoveUserModal: true
      });
    }
  }, {
    key: "isValidEmailAddress",
    value: function isValidEmailAddress(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }, {
    key: "saveNewUser",
    value: function saveNewUser() {
      var _this4 = this;
      var updatedUser = this.setUserData();
      if (CheckUtils.isNullOrEmptyString(updatedUser.businessEmail)) {
        this.setState({
          businessEmailNotComplete: true
        });
      } else if (!this.isValidEmailAddress(updatedUser.businessEmail)) {
        this.setState({
          emailNotValidate: true
        });
      } else if (CheckUtils.isNullOrEmptyString(updatedUser.phone)) {
        this.setState({
          phoneNotComplete: true
        });
      } else if (updatedUser.phone.replace(/[^\d]/g, '').length < 10) {
        this.setState({
          phoneNotValid: true
        });
      } else {
        this.setState({
          editModalSaveLoading: true
        });
        ApiClient.userManagement.updateEditUser(updatedUser).then(function () {
          _this4.setState({
            editModalSaveLoading: false,
            showEditUserModal: false,
            newSelectedRole: ''
          });
          _this4.loadUserList();
        }, function (error) {
          _this4.setState({
            editModalSaveLoading: false,
            showEditUserModal: false,
            newSelectedRole: '',
            showUpdateUserNotSuccessModal: true
          });
          Logger.error('--- ERROR ---');
          Logger.error(error);
        });
      }
    }
  }, {
    key: "onRemoveConfirmationOK",
    value: function onRemoveConfirmationOK() {
      var _this5 = this;
      this.setState({
        editModalLoading: true,
        showRemoveUserModal: false
      });
      ApiClient.userManagement.deleteUserProfile(this.state.removeUserInfo).then(function () {
        _this5.setState({
          editModalLoading: false,
          removeUserInfo: {}
        });
        _this5.loadUserList();
      }).catch(function (err) {
        _this5.setState({
          editModalLoading: false
        });
        Logger.error(err);
      });
    }
  }, {
    key: "handleSortUserNames",
    value: function handleSortUserNames() {
      this.setState(function (prevState) {
        return {
          toggleUserName: !prevState.toggleUserName
        };
      });
      if (this.state.toggleUserName) {
        var userList = _toConsumableArray(this.state.userList).sort(function (a, b) {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
        this.setState({
          userList: userList
        });
      } else {
        var _userList = _toConsumableArray(this.state.userList).sort(function (a, b) {
          if (a.name > b.name) return -1;
          if (a.name < b.name) return 1;
          return 0;
        });
        this.setState({
          userList: _userList
        });
      }
    }
  }, {
    key: "reloadAddUserPage",
    value: function reloadAddUserPage(event) {
      event.preventDefault();
      window.location.reload();
    }
  }, {
    key: "handleSortUserID",
    value: function handleSortUserID() {
      this.setState(function (prevState) {
        return {
          toggleUserId: !prevState.toggleUserId
        };
      });
      if (this.state.toggleUserId) {
        var userList = _toConsumableArray(this.state.userList).sort(function (a, b) {
          if (a.loginId.toLowerCase() > b.loginId.toLowerCase()) return -1;
          if (a.loginId.toLowerCase() < b.loginId.toLowerCase()) return 1;
          return 0;
        });
        this.setState({
          userList: userList
        });
      } else {
        var _userList2 = _toConsumableArray(this.state.userList).sort(function (a, b) {
          if (a.loginId.toLowerCase() < b.loginId.toLowerCase()) return -1;
          if (a.loginId.toLowerCase() > b.loginId.toLowerCase()) return 1;
          return 0;
        });
        this.setState({
          userList: _userList2
        });
      }
    }
  }, {
    key: "cancelModalData",
    value: function cancelModalData() {
      this.setState({
        showUpdateUserNotSuccessModal: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;
      var usersListData = this.state.userList;
      var _this$state2 = this.state,
        currentPage = _this$state2.currentPage,
        usersPerPage = _this$state2.usersPerPage;

      // Logic for displaying users
      var indexOfLastUser = currentPage * usersPerPage;
      var indexOfFirstUser = indexOfLastUser - usersPerPage;
      var currentUsers = usersListData.slice(indexOfFirstUser, indexOfLastUser);
      var renderUsers = currentUsers;
      var pageNumbers = [];
      for (var i = 1; i <= Math.ceil(usersListData.length / usersPerPage); i++) {
        pageNumbers.push(i);
      }
      var renderPageNumbers = pageNumbers.map(function (number) {
        return /*#__PURE__*/React.createElement("li", {
          key: number,
          id: number,
          onClick: _this6.handleClick,
          className: "".concat(_this6.state.currentPage === number ? 'active-page-No' : ' ')
        }, number);
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "users-data-list"
      }, /*#__PURE__*/React.createElement(Loader, {
        show: this.state.editModalLoading,
        message: spinner,
        contentBlur: loaderOpacity,
        backgroundStyle: loaderBackgroundStyle
      }, /*#__PURE__*/React.createElement("div", {
        className: "data-list-spot__table-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "data-list-spot__table headers"
      }, /*#__PURE__*/React.createElement("div", {
        className: "data-list-spot__headers"
      }, /*#__PURE__*/React.createElement("div", {
        className: "data-list-spot__headers__header sortable ".concat(this.state.toggleUserName ? 'ordered_asc' : 'ordered_desc'),
        onClick: this.handleSortUserNames,
        onKeyPress: this.handleSortUserNames,
        role: "button",
        "data-title": "userName",
        tabIndex: "0"
      }, /*#__PURE__*/React.createElement("span", null, this.translations.dataListUserNameText)), /*#__PURE__*/React.createElement("div", {
        className: "data-list-spot__headers__header data-user-id sortable ".concat(this.state.toggleUserId ? 'ordered_asc' : 'ordered_desc'),
        onClick: this.handleSortUserID,
        onKeyPress: this.handleSortUserID,
        role: "button",
        "data-title": "userId",
        tabIndex: "0"
      }, /*#__PURE__*/React.createElement("span", null, this.translations.dataListUserText)), /*#__PURE__*/React.createElement("div", {
        className: "data-list-spot__headers__header roles",
        role: "button",
        "data-title": "role",
        tabIndex: "0"
      }, /*#__PURE__*/React.createElement("span", null, this.translations.dataListRoleText)), /*#__PURE__*/React.createElement("div", {
        className: "data-list-spot__headers__header",
        role: "button",
        "data-title": "manage",
        tabIndex: "0"
      }, /*#__PURE__*/React.createElement("span", null, this.translations.dataListManageText))), renderUsers.map(function (users, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "data-list-spot__row data-list-spot__row__cell ".concat(1),
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          className: "data-list-spot__row__column"
        }, users.name), /*#__PURE__*/React.createElement("div", {
          className: "data-list-spot__row__column"
        }, users.loginId), /*#__PURE__*/React.createElement("div", {
          className: "data-list-spot__row__column"
        }, users.role), /*#__PURE__*/React.createElement("div", {
          className: "data-list-spot__row__column"
        }, users.loginId.toLowerCase() === _this6.state.loggedUser.toLowerCase() ? '' : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
          className: "manage-edit",
          onClick: function onClick() {
            return _this6.openEditModal(users);
          }
        }, _this6.translations.dataListEditText), /*#__PURE__*/React.createElement("a", {
          onClick: function onClick() {
            return _this6.openRemoveModal(users);
          }
        }, _this6.translations.dataListRemoveText))));
      }))), usersListData.length <= 0 && /*#__PURE__*/React.createElement("div", {
        className: "no-users-found-text"
      }, "User information could not be loaded at this time. Please reload the page or ", /*#__PURE__*/React.createElement("a", {
        href: "mailto:helpwithmyoticon@oticon.com"
      }, "\xA0 contact us \xA0"), " for assistance."), /*#__PURE__*/React.createElement("ul", {
        id: "page-numbers"
      }, renderPageNumbers), /*#__PURE__*/React.createElement(UserManagementEditModal, {
        userManagementEditModalIsOpen: this.state.showEditUserModal,
        editUser: this.state.editUser,
        onEditUserUpdated: function onEditUserUpdated(businessEmail, personalEmail, phone, fax) {
          _this6.handleUpdateEditUser(businessEmail, personalEmail, phone, fax);
        },
        onSaveEditModal: this.saveNewUser,
        closeModal: this.modalCancel,
        passSelectedRole: this.passSelectedRole,
        businessEmailRequired: this.state.businessEmailNotComplete,
        emailValidate: this.state.emailNotValidate,
        phoneNoRequired: this.state.phoneNotComplete,
        phoneNoValid: this.state.phoneNotValid,
        saveLoading: this.state.editModalSaveLoading
      }), /*#__PURE__*/React.createElement(ModalDialog, {
        isOpen: this.state.showRemoveUserModal,
        type: ModalDialog.types.okCancel,
        onOkClick: function onOkClick() {
          return _this6.onRemoveConfirmationOK();
        },
        okLabel: this.translations.removeModalOKText,
        onCancelClick: function onCancelClick() {
          return _this6.onRemoveUserCanceled();
        },
        cancelLabel: this.translations.removeModalCancelText
      }, /*#__PURE__*/React.createElement("p", null, this.translations.dataListRemoveModalText, " ", this.state.removeUserName, "?")), /*#__PURE__*/React.createElement(ModalDialog, {
        isOpen: this.state.showUpdateUserNotSuccessModal,
        type: ModalDialog.types.okCancel,
        okLabel: "Try again",
        onOkClick: function onOkClick() {
          return _this6.cancelModalData();
        },
        onCancelClick: function onCancelClick() {
          return _this6.cancelModalData();
        },
        cancelLabel: "Cancel"
      }, /*#__PURE__*/React.createElement("p", null, "We\u2019re sorry, an error has occurred. Please try again. If the issue continues, please contact us at ", /*#__PURE__*/React.createElement("a", {
        href: "mailto: helpwithmyoticon@oticon.com"
      }, "helpwithmyoticon@oticon.com")))));
    }
  }]);
}(React.Component);
export default UserManagementUsersDataList;